
/**
 * Module dependencies.
 */

import { canUseDOM } from '../dom';
import { useEffect, useState } from 'react';

/**
 * Export `useMediaQuery`.
 */

export function useMediaQuery(query: string): boolean {
  const [matches, setMatches] = useState(() => canUseDOM() && window.matchMedia(query).matches);

  useEffect(() => {
    const media = window.matchMedia(query);
    const listener = () => setMatches(media.matches);

    media.addEventListener('change', listener);

    return () => {
      media.removeEventListener('change', listener);
    };
  }, [query]);

  return matches;
}
